{
  "language": {
    "label": "Език",
    "names": {
      "bg": "Български",
      "en": "English"
    }
  },
  "theme": {
    "label": "Външен вид",
    "names": {
      "system": "Системна",
      "light": "Светла",
      "dark": "Тъмна"
    }
  },
  "errors": {
    "auth": {
      "confirmation_invalid": "Връзката за потвърждение е невалидна или е изтекла.",
      "email_taken": "Този имейл адрес вече е регистриран.",
      "external_signup_failed": "Не можа да бъде създаден акаунт с това вписване.",
      "failed": "Влизането не успя. Моля, опитайте отново.",
      "firebase_not_configured": "Входът с код през Firebase не е настроен тук.",
      "invalid_credentials": "Грешен имейл или парола",
      "last_credential": "Това е единственият ви начин за вход и не може да бъде премахнат.",
      "link_failed": "Този начин за вход не можа да бъде свързан с акаунта ви.",
      "otp_invalid": "Кодът е грешен или е изтекъл.",
      "otp_rate_limited": "Твърде много заявки за код. Изчакайте няколко минути и опитайте отново.",
      "otp_daily_limit": "Днес не могат да се изпращат повече кодове за вход. Опитайте утре или ни се обадете, за да поръчате.",
      "otp_signup_failed": "Не можа да бъде създаден акаунт за този номер.",
      "refresh_token_expired": "Сесията ви изтече. Моля, влезте отново.",
      "refresh_token_invalid": "Сесията ви вече не е валидна. Моля, влезте отново.",
      "refresh_token_reused": "Сесията ви беше прекратена за сигурност. Моля, влезте отново.",
      "refresh_token_wrong_tenant": "Тази сесия принадлежи на друга фирма.",
      "reset_token_invalid": "Връзката за нова парола е невалидна или е изтекла.",
      "session_expired": "Сесията ви изтече. Моля, влезте отново.",
      "unauthenticated": "Необходимо е влизане"
    },
    "tenant": {
      "not_resolved": "Непозната фирма",
      "not_found": "Непозната фирма",
      "slug_taken": "Този код на фирма вече е зает",
      "inbound_number_taken": "Друга фирма вече приема обаждания на този номер",
      "host_taken": "Друга фирма вече отговаря на този адрес"
    },
    "dispatch": {
      "driver_unavailable": "Този шофьор не е свободен",
      "driver_on_another_order": "Този шофьор вече е зает с поръчка {{reference}}",
      "order_finished": "Тази поръчка вече е приключила",
      "no_open_assignment": "Този шофьор не държи тази поръчка",
      "driver_cannot_cancel": "Само офисът може да откаже курс, който ви е дал"
    },
    "telephony": {
      "pbx_unavailable": "Телефонната централа не отговаря.",
      "pbx_unauthorised": "Телефонната централа отхвърли тези данни за достъп.",
      "call_not_controllable": "Този разговор вече не е ваш, за да го променяте.",
      "not_enabled": "Тази фирма няма настроена телефонна централа.",
      "no_extension": "Все още нямате телефон. Презаредете конзолата, за да получите.",
      "realtime_unavailable": "Базата с вътрешните номера на централата не отговаря.",
      "recording_disabled": "Тази фирма не записва разговори.",
      "recording_unavailable": "Този запис вече не е наличен.",
      "all_lines_busy": "Всички линии за изходящи разговори са заети. Опитайте отново след малко.",
      "no_outbound_lines": "Никоя от линиите за изходящи разговори вече не съществува. Изберете ги отново в настройките за телефония.",
      "call_flow_not_enabled": "Режимът на разговорите на тази фирма не задържа обаждащи се.",
      "hold_lines_full": "Всички линии, които могат да задържат клиент, вече задържат ({{held}} от {{max}}). Кажете на клиента, че ще му позвъните.",
      "no_desk_phone_extension": "Всички номера за настолни телефони от 7500 до 7999 са използвани.",
      "no_telephone": "В момента нито един от телефоните ви не е достъпен. Проверете дали настолният телефон е включен или отворете телефона в конзолата.",
      "desks_belong_to_dispatchers": "Тук настолните телефони са на диспечерите. Администраторът ви дава вашия.",
      "mac_taken": "Друг настолен телефон вече има този MAC адрес — тук или в друга фирма.",
      "desk_has_phones": "На бюрото още има телефони. Преместете ги на друго бюро или ги премахнете първо.",
      "line_name_taken": "Централата вече има линия с това име в собствените си настройки. Оставете паролата празна, за да я добавите такава, каквато е, или изберете друго име."
    },
    "call": {
      "not_found": "Няма такъв разговор",
      "already_handled": "Някой вече е поел този разговор",
      "not_an_order": "Първо приемете поръчката — още няма какво да чака клиентът.",
      "not_connected": "Този клиент в момента не разговаря с никого.",
      "not_on_hold": "Този клиент вече не е на изчакване.",
      "not_ringing": "Този разговор вече не звъни — някой го е вдигнал, или клиентът е затворил."
    },
    "driver": {
      "not_found": "Няма такъв шофьор",
      "already_hired": "Този човек вече е шофьор във фирмата."
    },
    "membership": {
      "not_found": "Този човек не е част от тази фирма"
    },
    "customer": {
      "not_found": "Няма такъв клиент",
      "already_linked": "Този клиент вече е свързан с акаунт"
    },
    "order": {
      "not_found": "Няма такова пътуване",
      "illegal_transition": "В момента това не е възможно",
      "not_rateable": "Може да се оцени само приключило пътуване",
      "pre_bookings_disabled": "Фирмата не приема поръчки за по-късно.",
      "cancellation_reason_unknown": "Тази причина вече не е в списъка. Изберете друга.",
      "cancellation_reason_name_taken": "Друга причина вече е с това име."
    },
    "rider": {
      "blocked": "Този акаунт не може да поръчва. Моля, обадете се в офиса.",
      "no_phone": "Този акаунт няма потвърден телефонен номер."
    },
    "password": {
      "breached": "Тази парола се е появявала в изтекли данни. Моля, изберете друга."
    },
    "shift": {
      "driver_inactive": "Този шофьор не е активен",
      "vehicle_inactive": "Тази кола не е активна",
      "no_vehicle": "Няма назначена кола",
      "driver_document_expired": "Документ на шофьора е изтекъл",
      "vehicle_document_expired": "Документ на колата е изтекъл",
      "driver_document_missing": "Липсва задължителен документ на шофьора",
      "vehicle_document_missing": "Липсва задължителен документ на колата",
      "order_in_progress": "Има пътуване в момента",
      "vehicle_not_allowed": "Офисът не ви е разрешил кола {{plate}}. Изберете някоя от вашите или попитайте офиса.",
      "vehicle_taken": "Друг шофьор току-що взе кола {{plate}}. Изберете друга."
    },
    "validation": {
      "coordinates_required": "Изберете адрес от списъка, за да се запише местоположението",
      "invalid_phone_number": "Това не прилича на телефонен номер",
      "in_the_future": "Този момент е в бъдещето",
      "implausible_coordinates": "Тези координати не са възможни",
      "at_least_one_required": "Попълнете поне едно от тези",
      "out_of_range": "Стойността е извън допустимия обхват",
      "unknown_order_state": "Непознато състояние на поръчка",
      "unknown_shift_state": "Непознато състояние на смяна",
      "unknown_no_cars_action": "Непознато действие при липса на свободни коли",
      "unknown_outbound_line_strategy": "Непознато правило за линията на изходящите разговори",
      "unknown_call_flow": "Непознат режим на обработка на разговорите",
      "unknown_hold_expiry": "Непознато действие при изтекло изчакване",
      "invalid_format": "Стойността не е записана във формата, който полето изисква",
      "not_a_url": "Това не прилича на уеб адрес",
      "required": "Това е необходимо",
      "unknown_payment_method": "Непознат начин на плащане",
      "unknown_day_of_week": "Непознат ден от седмицата",
      "invalid_slug": "Кодът на фирмата се състои от малки латински букви, цифри и тирета и започва с буква",
      "reserved_slug": "Това име е запазено за самата платформа — изберете друг код",
      "unknown_culture": "Непознат език и регион",
      "unknown_time_zone": "Непозната часова зона",
      "unknown_currency": "Непозната валута",
      "invalid_calling_code": "Кодът за избиране е от една до четири цифри, без плюса",
      "not_a_colour": "Цветът се изписва като #RRGGBB",
      "unknown_document_owner": "Документът принадлежи на шофьор или на автомобил.",
      "unknown_document_kind": "Това не е вид документ, който системата записва.",
      "unknown_phone_line_kind": "Линията е за поръчки, мобилен, офис, WhatsApp или Viber",
      "one_support_line": "Само една линия може да е тази, на която звънят приложенията",
      "invalid_line_name": "Името на линия е малки латински букви, цифри, тирета и долни черти, започва с буква — името, под което я знае централата",
      "already_listed": "Това вече е в списъка",
      "set_on_the_pbx": "Тази линия е настроена в собствените настройки на централата, където е и паролата ѝ, ако има такава",
      "too_long": "Това е твърде дълго",
      "not_an_address": "Това не прилича на мрежов адрес",
      "unknown_line_kind": "Линията е SIM карта или транк",
      "missing_number": "Липсва номер",
      "not_a_full_number": "„{{typed}}“ не е пълен номер — напишете го с кода, например {{example}}",
      "unknown_line": "Това не е линия на фирмата",
      "zone.circle_incomplete": "Щракнете на картата, за да поставите центъра на кръга",
      "zone.polygon_incomplete": "Щракнете на картата, за да начертаете поне три върха",
      "zone.cycle": "Зона не може да е вътре в себе си",
      "zone.too_deep": "Зоните се влагат най-много на три нива; този родител вече е най-отдолу",
      "zone.has_children": "Първо премахнете или преместете зоните вътре в тази",
      "surcharge.no_effect": "Дайте на тарифата процент или сума; на нула тя не би променила нищо",
      "unknown_surcharge_kind": "Правилото важи в определени часове или на празници",
      "unknown_surcharge_mode": "Правилото има собствени цени или надбавка",
      "not_a_host_name": "Това не е уеб адрес: букви, цифри и тирета, разделени с точки",
      "reserved_host": "Този адрес е на самата платформа — изберете друг",
      "too_many": "Твърде много наведнъж — изберете по-малко"
    },
    "request": {
      "failed": "Заявката не можа да бъде изпълнена",
      "malformed": "Заявката не можа да бъде прочетена",
      "rate_limited": "Твърде много заявки. Изчакайте момент и опитайте отново."
    },
    "server": {
      "unexpected": "Нещо се обърка. Моля, опитайте отново."
    },
    "unknown": "Нещо се обърка",
    "billing": {
      "no_duty_rate": "Фирмата още не е определила колко струва един работен ден.",
      "payment_already_reversed": "Това плащане вече е сторнирано",
      "payment_is_a_reversal": "Сторно не може да се сторнира. Запишете ново плащане."
    },
    "duty_rate": {
      "not_found": "Няма такава ставка"
    },
    "driver_payment": {
      "not_found": "Няма такова плащане"
    },
    "duty": {
      "not_shared": "Тази фирма се разплаща в офиса, а не през приложението."
    },
    "feature": {
      "not_included": "Вашата фирма няма тази функционалност"
    },
    "branding": {
      "logo_too_large": "Изображението е твърде голямо. Логото може да е най-много 512 KB.",
      "logo_not_an_image": "Файлът не е PNG, JPEG или WebP изображение."
    },
    "import": {
      "unknown_format": "Този формат на файл не може да бъде прочетен",
      "unreadable": "Файлът не е във формата, с който беше качен",
      "not_utf8": "Файлът не е UTF-8. Изглежда като {{encoding}} — запишете го като UTF-8 и опитайте отново.",
      "no_phone": "Липсва телефонен номер",
      "bad_phone": "Телефонният номер не може да бъде разчетен",
      "withheld_number": "Скрит номер, зад който няма човек",
      "bad_coordinates": "Координати, които не са на картата"
    },
    "invite": {
      "invalid": "Тази връзка за покана не е валидна.",
      "expired": "Поканата е изтекла. Помолете за нова.",
      "already_accepted": "Поканата вече е използвана. Влезте в профила си.",
      "not_found": "Няма покана, която да бъде изпратена отново.",
      "platform_account": "Този адрес е на оператор на платформата, който не може да бъде част от фирма. Помолете поканата да бъде изпратена на друг адрес."
    },
    "vehicle": {
      "not_found": "Няма такъв автомобил",
      "plate_taken": "Друг автомобил вече е с този регистрационен номер.",
      "category_unknown": "Фирмата няма клас автомобили „{{code}}“.",
      "feature_unknown": "Колите на фирмата не предлагат „{{code}}“.",
      "feature_name_taken": "Друг етикет вече е с това име.",
      "feature_picture_too_large": "Снимката може да е най-много {{maxBytes}} байта.",
      "feature_picture_not_an_image": "Файлът не е снимка във формат PNG, JPEG или WebP."
    },
    "document": {
      "not_found": "Няма такъв документ"
    },
    "mfa": {
      "challenge_invalid": "Това влизане вече не е в изчакване. Започнете отначало.",
      "challenge_expired": "Влизането отне твърде дълго. Започнете отначало.",
      "invalid_code": "Кодът не е верен.",
      "too_many_attempts": "Твърде много опити. Започнете влизането отначало.",
      "already_enrolled": "Този акаунт вече има автентикатор. Въведете код от него."
    },
    "setup": {
      "step_unknown": "Това не е стъпка от настройката на тази фирма",
      "step_required": "Тази стъпка не може да се отбележи като ненужна — без нея фирмата не може да приеме поръчка"
    },
    "message": {
      "disabled": "Тази фирма не разменя съобщения с шофьорите през приложението.",
      "empty": "Напишете нещо или изберете готова фраза.",
      "too_long": "Съобщението е твърде дълго.",
      "unknown_code": "Това не е сред готовите фрази."
    },
    "alarm": {
      "disabled": "Приложението на тази фирма няма аларма.",
      "not_found": "Няма такава аларма"
    },
    "heading_home": {
      "disabled": "Тази фирма не приема от шофьорите накъде пътуват.",
      "off_duty": "Първо започнете смяна.",
      "no_saved_home": "Първо запазете адреса на дома."
    },
    "rating": {
      "disabled": "Тази фирма не иска от шофьорите да оценяват клиентите."
    },
    "heatmap": {
      "disabled": "Тази фирма не показва на шофьорите къде има работа."
    },
    "taximeter": {
      "disabled": "Приложението на тази фирма няма таксиметър."
    },
    "street_ride": {
      "disabled": "Тази фирма не записва в приложението пътници, качени от улицата.",
      "off_duty": "Първо започнете смяната.",
      "offer_open": "Първо отговорете на предложената поръчка.",
      "no_position": "Телефонът още не е казал къде е. Изчакайте малко и опитайте пак."
    },
    "place": {
      "not_found": "Този адрес вече не е в списъка на фирмата",
      "duplicate": "{{line}} вече е в списъка на фирмата",
      "name_taken": "Друг адрес вече се казва „{{name}}“: {{line}}",
      "entrance_invalid": "Входът е една буква или число с една-две цифри",
      "entrance_needs_number": "Входът е на номер на къща или блок — добавете номера към адреса",
      "nothing_waiting": "Тук вече нищо не чака одобрение",
      "not_allowed": "Фирмата не позволява това",
      "door_not_named": "Адресът на това пътуване не посочва вход за запомняне",
      "door_not_a_place": "Адресът на това пътуване не е от адресите на фирмата",
      "door_wrong_moment": "Мястото се запазва, след като пътникът се качи",
      "door_inaccurate": "Телефонът не е сигурен къде се намира — опитайте отново след малко",
      "door_too_far": "Мястото е твърде далеч от адреса, за да е неговият вход",
      "google_name_unchanged": "Този адрес е от Google. Напишете го по свой начин, преди да го заключите",
      "google_pin_unmoved": "Този адрес е от Google. Преместете точката на самия вход, преди да го заключите",
      "join_empty": "Нищо не е избрано за присъединяване.",
      "join_conflict": "Това присъединяване вече е към друг адрес.",
      "join_undone": "Присъединяването е отменено."
    },
    "report": {
      "row_gone": "Редът вече се промени — списъкът е презареден."
    },
    "place_change": {
      "not_found": "Тази версия на адреса я няма в историята му"
    },
    "place_report": {
      "not_found": "Този сигнал вече не чака"
    },
    "place_join": {
      "not_found": "Присъединяването не е намерено."
    },
    "geo": {
      "google_not_configured": "Тази инсталация няма ключ за Google, затова приложението за пътници не може да търси в Google."
    },
    "device": {
      "requests_off": "Тази фирма не приема заявки за служебно устройство. Помолете офиса за QR код.",
      "not_enrolled": "Този телефон не е регистриран като служебно устройство.",
      "retired": "Офисът отписа това устройство.",
      "request_rejected": "Офисът отказа заявката от този телефон.",
      "request_closed": "Заявката вече е отговорена или е изтекла.",
      "in_use_elsewhere": "Акаунтът се ползва от друг телефон.",
      "ticket_invalid": "Този QR код е използван или е изтекъл. Помолете офиса за нов.",
      "staff_account": "Този човек работи и в офиса. Служебното устройство е само за шофьор.",
      "rate_limited": "Твърде много заявки. Опитайте пак след малко.",
      "account_inactive": "Акаунтът на този телефон е спрян от офиса.",
      "stopped": "Този телефон вече не е на акаунта: офисът го премахна или шофьорът работи от друг.",
      "identity_invalid": "Телефонът не можа да се представи. Затворете приложението и опитайте пак."
    }
  },
  "states": {
    "Requested": "Чакаща",
    "Assigned": "Възложена",
    "EnRouteToPickup": "Пътува към клиента",
    "WaitingForRider": "Изчаква клиента",
    "OnBoard": "В движение",
    "Completed": "Завършена",
    "Cancelled": "Отказана",
    "NoShow": "Клиентът не се яви"
  },
  "actors": {
    "Rider": "Клиент",
    "Driver": "Шофьор",
    "Dispatcher": "Диспечер",
    "System": "Система"
  },
  "shiftStates": {
    "Available": "Свободен",
    "Busy": "Зает",
    "OnBreak": "В почивка",
    "OffDuty": "Извън смяна"
  },
  "fare": {
    "base": "Начална такса",
    "distance": "{{kilometres}} км по {{rate}}",
    "time": "{{minutes}} мин по {{rate}}",
    "waiting": "{{minutes}} мин чакане по {{rate}} (първите {{free}} безплатно)",
    "surcharge": "{{name}}",
    "minimum": "Минимална сума {{minimum}}",
    "rounding": "Закръгляне",
    "cancellation": "Такса за отказ",
    "no_show": "Такса за неявяване"
  },
  "vehicles": {
    "classLabel": "Клас",
    "featuresLabel": "Изисквания",
    "anyClass": "Без значение",
    "class": {
      "standard": "Стандартна",
      "estate": "Комби",
      "van": "Ван"
    },
    "feature": {
      "suitcases": "Куфари",
      "small_pet": "Малък любимец, до 5 кг",
      "big_pet": "Голям любимец, над 5 кг",
      "card_payment": "Плащане с карта",
      "baby_stroller": "Бебешка количка",
      "wheelchair": "Инвалидна количка"
    },
    "featureShort": {
      "suitcases": "Куфари",
      "small_pet": "Малък любимец",
      "big_pet": "Голям любимец",
      "card_payment": "С карта",
      "baby_stroller": "Бебешка количка",
      "wheelchair": "Инвалидна количка"
    }
  },
  "driverMessages": {
    "driver": {
      "on_my_way": "Тръгвам",
      "running_late": "Закъснявам",
      "passenger_not_here": "Клиентът го няма",
      "call_me": "Моля, обадете ми се",
      "break_ten": "Почивка десет минути",
      "car_problem": "Проблем с колата",
      "ok": "Добре"
    },
    "office": {
      "call_office": "Моля, обадете се в офиса",
      "wait_there": "Моля, изчакайте там",
      "passenger_coming": "Клиентът излиза",
      "go_to_rank": "Моля, отидете на стоянката",
      "hurry": "Моля, побързайте",
      "ok": "Добре"
    }
  },
  "cancellationReasons": {
    "changed_mind": "Промених плановете си",
    "waited_too_long": "Чаках твърде дълго",
    "found_other": "Намерих друг транспорт",
    "wrong_address": "Сгреших адреса",
    "other": "Друго"
  }
}
